<template>
  <div>
    <div style="text-align: center;display:flex;align-items: center;width: 100%;"
         :style="{'height': loaderHeight + 'px'}" v-show="isLoading || (posts.length === 0 && isLoading === false)">
      <div style="margin:0 auto">
        <img width="100px" src="static/loader-gif.gif" class="rounded"/>
        <br/>
        {{ $t('message.loadingText') }}
      </div>
    </div>
    <div id="lifeView" v-if="isLoading === false && posts.length > 0">
      <div class="life-header" :style="`background-position: center center;background-size: cover;background-image: linear-gradient(180deg,rgba(0,0,0,.68),rgba(0,0,0,.68)),url(${posts[0].post_image});`">
        <span>Trending now</span>
        <h1>{{ posts[0].post_title }}</h1>
        <mu-flat-button :to="`life/${posts[0].post_slug}`" label="Read now" />
      </div>
      <div class="content">
        <mu-row>
          <mu-col width="100" tablet="100" desktop="100">
            <life-search-bar />
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col width="100" tablet="100" desktop="75">
            <div id="lifeRecommendations" class="section" v-if="hasRecommendations && !isHcpView">
              <h2>Recommended reading</h2>
              <mu-flexbox justify="flex-start" align="stretch" wrap="wrap">
                <mu-flexbox-item v-for="post, index in shuffleRecommendations" :key="`recommendation-${index}`" v-if="index <= 2" basis="25%">
                  <life-post-info
                    :slug="post.post_slug"
                    :image="post.post_image"
                    :title="post.post_title"
                    :time="post.post_date"
                    :favourites="post.post_favourites"
                  />
                </mu-flexbox-item>
              </mu-flexbox>
            </div>
            <div class="section">
              <h2 v-text="$t('message.lifeBrowseCategory')"></h2>
              <div id="listCats">
                <div class="cat-col">
                  <mu-card class="cat" style="background-image: url('static/life/coffee-heart.jpg')">
                    <router-link to="/life/my-favourites" @click.native="goToFavourites()">
                      <div class="overlay">
                        <div class="catMeta">
                          <h3 class="title" v-text="$t('message.lifeMyFavourites')"></h3>
                        </div>
                      </div>
                    </router-link>
                  </mu-card>
                </div>
                <div class="cat-col" v-for="cat, index in cats" :key="'cat-' + index" v-if="cat.count !== 0">
                  <mu-card class="cat" :style="{'background-image':'url('+ cat.image +')'}">
                    <router-link :to="{}" @click.native="goTo(cat.slug)">
                      <div class="overlay">
                        <div class="catMeta">
                          <h3 class="title" v-html="$sanitize(localizeLifeCat(cat.term_id) || cat.name)"></h3>
                          <span class="count" v-once>{{ cat.count }} {{ cat.count === 1 ? $t('message.labelArticle') : $t('message.labelArticles') }}</span>
                        </div>
                      </div>
                    </router-link>
                  </mu-card>
                </div>
              </div>
            </div>
          </mu-col>
          <mu-col width="100" tablet="100" desktop="25">
            <div id="lifeSideBar" v-if="posts.length">
              <div class="sidePost" v-for="post, index in posts" :key="`sidepost-${index}`">
                <life-post-info
                  :slug="post.post_slug"
                  :image="post.post_image"
                  :title="post.post_title"
                  :time="post.post_date"
                  :favourites="post.post_favourites"
                />
              </div>
            </div>
          </mu-col>
        </mu-row>
      </div>
    </div>
  </div>
</template>

<script>

import LifeStyleApi from '../../api/LifeStyle/index';

import LifeSearchBar from "../../components/LifeStyle/LifeSearchBar/LifeSearchBar";
import LifeMixin from '../../mixins/Localization/Life';
import HcpMixin from '../../mixins/HCPMixin';
import LifePostInfo from "../../components/LifeStyle/LifePostInfo/LifePostInfo";

export default {
    mixins: [
      LifeMixin,
      HcpMixin
    ],
    components: {
      LifeSearchBar,
      LifePostInfo
    },
    name: 'life-style',
    watch: {
      '$route': function () {
        let self = this;
        self.initMounted();
      },
      isLoading: function () {
        if (this.isLoading === false) {
          $('.main-content').attr('style', 'overflow-y: scroll')
        }
      },
    },
    data () {
      return {
        posts: [],
        cats: [],
        recommendations: [],
        isLoading: true,
        loaderHeight: 0,
      }
    },
    methods: {
      goToFavourites() {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            name: 'LifeStyleFavourites',
          });
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      },
      loadPosts() {
        this.isLoading = true;
        LifeStyleApi.getPosts(1, 12, 'medium').then(response => {
          this.posts = response.data;
          this.isLoading = false;
        });
      },
      loadCats() {
        let self = this;
        LifeStyleApi.getCategorys().then(response => {
          let data = response.data;
          self.cats = data;
        });
      },
      goTo(slug) {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            name: 'LifeStyleCategory',
            params: {
              slug: slug,
            }
          });
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      },
      moment(date) {
        return moment(date);
      },
      goToArticle(slug) {
        let self = this;
        if (self.$store.state.status.payment.paid) {
          self.$router.push({
            name: 'LifeStyleArticle',
            params: {
              permalink: slug
            }
          });
        } else {
          self.$EventBus.$emit('App::triggerPaywall', true);
        }
      },
      initMounted() {
        let self = this;

        $('.main-content').attr('style', 'overflow-y: hidden')

        const loaderHeight = $('.main-content').outerHeight();
        self.loaderHeight = loaderHeight;

        self.isLoading = true;
        self.loadPosts();
        self.loadCats();
        setTimeout(function () {
          self.isLoading = false;
        }, 2500);
      }
    },
    computed: {
      shuffleRecommendations() {
        let self = this;
        return _.shuffle(self.recommendations);
      },
      hasRecommendations() {
        let self = this;
        return self.recommendations.length;
      }
    },
    mounted () {
      let self = this;
      self.initMounted();
    },
  }

</script>
<style lang="less">
  @import "./LifeStyle.less";
  div#lifestyle {
    padding-top: 0;
    margin-top: -65px;
    padding-left: 0;
    padding-right: 0;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// LifeStyle.vue?3208e96f